import React, { useMemo } from 'react';
import { ItemPlaceholder } from 'src/features/white-labels/ocean/shared/components/item-placeholder';
import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { Grid } from 'src/ui/common/atoms/grid';
import { StyledDetails, StyledWrapper } from './empty-list-placeholder.styles';

export const EmptyListPlaceholder = ({
    itemsGridConfig,
    children,
    className,
}: {
    itemsGridConfig: any;
    children?: React.ReactNode;
    className?: string;
}) => {
    const screen = useScreenDetect();

    const itemsCount = useMemo(() => {
        if (screen.xs) {
            return itemsGridConfig.xs;
        }
        if (screen.sm) {
            return itemsGridConfig.sm;
        }
        if (screen.md) {
            return itemsGridConfig.md;
        }
        if (screen.lg) {
            return itemsGridConfig.lg;
        }
        return itemsGridConfig.xl;
    }, [screen, itemsGridConfig]);

    return (
        <StyledWrapper className={className}>
            <Grid rowGap={10} columnGap={10} rowGapSm={20} columnGapLg={15} {...itemsGridConfig}>
                {Array.from({ length: itemsCount }).map((k_, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <ItemPlaceholder key={i} />
                ))}
            </Grid>
            <StyledDetails alignItems="center" flexDirection="column">
                {children}
            </StyledDetails>
        </StyledWrapper>
    );
};
